var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { timeoutPromise } from 'bernie-core';
import loadable from '@loadable/component';
import { getTrackingInfoForLogging } from '../common/logging-utils';
import { handleInvalidDates } from '../helpers/controller-date-helper';
import { getPageData } from '../utils/controller-utils/get-page-data';
var SERVER_CONTROLLER_FETCH = 15000;
var CLIENT_CONTROLLER_FETCH = 25000;
var ActivityDetailController = /** @class */function () {
  function ActivityDetailController() {
    this.pageId = 'page.LX.Infosite.Information,A,30';
    // Must update valid-url-check.js if this path ever changes
    this.path = '/:lang?/things-to-do/:title?.a:activityId\\.([a-z\\-]{5,})';
    this.routeName = 'activity-detail';
    // eslint-disable-next-line import/no-unresolved
    this.component = loadable({
      resolved: {},
      chunkName() {
        return "detail-page";
      },
      isReady(props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function () {
        return import(/* webpackChunkName: "detail-page" */'views/activity-detail-page');
      },
      requireAsync(props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(resolved => {
          this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync(props) {
        const id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("views/activity-detail-page");
        }
        return eval('require.resolve')("views/activity-detail-page");
      }
    });
    this.exact = true;
    this.caseSensitive = true;
    this.useV5RoutePaths_deprecated = true; // eslint-disable-line
    this.clientSideFirstLoadRequested = true;
  }
  ActivityDetailController.prototype.fetch = function (options) {
    return __awaiter(this, void 0, Promise, function () {
      var stores, query, params, detailCriteriaStore, activityDetailStore, analyticsStore, experimentStore, context, changedVariables;
      return __generator(this, function (_a) {
        stores = options.stores, query = options.query, params = options.params;
        detailCriteriaStore = stores.get('detailCriteriaStore');
        activityDetailStore = stores.get('activityDetailStore');
        analyticsStore = stores.get('analytics');
        experimentStore = stores.get('experiment');
        context = stores.get('context');
        detailCriteriaStore.setContext(context);
        detailCriteriaStore.localDateFormat = context.localDateFormat;
        activityDetailStore.query = query;
        activityDetailStore.serverSide = options.isServer === true;
        activityDetailStore.setAnalyticsStore(analyticsStore);
        activityDetailStore.setExperimentStore(experimentStore);
        activityDetailStore.setPageLoading(true);
        changedVariables = detailCriteriaStore.changedQueryKeys(query, params.activityId);
        if (changedVariables.indexOf('activityId') !== -1 || !activityDetailStore.activityDetail) {
          return [2 /*return*/, timeoutPromise(this._getNewActivityDetailPage(activityDetailStore, detailCriteriaStore, query, options, params, context, analyticsStore), options.isServer ? SERVER_CONTROLLER_FETCH : CLIENT_CONTROLLER_FETCH, "controller=detail fetch=getNewActivityDetailPage timeout ".concat(getTrackingInfoForLogging(context)))];
        }
        if (changedVariables.indexOf('startDate') !== -1 || changedVariables.indexOf('endDate') !== -1) {
          return [2 /*return*/, this._getChangeDateResponse(activityDetailStore, detailCriteriaStore, query, analyticsStore).then()];
        }
        // Request these from the client side after server call
        return [2 /*return*/, Promise.resolve()];
      });
    });
  };
  ActivityDetailController.prototype._getChangeDateResponse = function (activityDetailStore, detailCriteriaStore, query, analyticsStore) {
    var _this = this;
    detailCriteriaStore.detailQuery = query;
    activityDetailStore.resetActivityOffers();
    return activityDetailStore.fetchActivityOffersWithAvailability(detailCriteriaStore.detailVariables, detailCriteriaStore, this.pageId, query).then(function () {
      analyticsStore.resetAnalyticsForNewPage();
      _this._publishAnalytics(activityDetailStore, analyticsStore);
    });
  };
  ActivityDetailController.prototype._getNewActivityDetailPage = function (activityDetailStore, detailCriteriaStore, query, options, params, context, analyticsStore) {
    var _this = this;
    detailCriteriaStore.resetDetailCriteriaStore();
    detailCriteriaStore.setContext(context);
    var preloadedActivity;
    // Case of browser back from another infosite
    if (activityDetailStore.activityDetail) {
      preloadedActivity = {
        id: params.activityId,
        primary: {},
        features: {},
        activityDuration: {},
        leadTicketPrice: {}
      };
    }
    activityDetailStore.resetDetailsPage(preloadedActivity);
    detailCriteriaStore.detailQuery = query;
    detailCriteriaStore.setActivityId(params.activityId);
    detailCriteriaStore.detailQuery = handleInvalidDates(query, detailCriteriaStore.detailQuery, detailCriteriaStore.localDateFormat);
    return this._getNewActivityFetchPromise(activityDetailStore, context, detailCriteriaStore, query, options).then(function () {
      analyticsStore.resetAnalyticsForNewPage();
      _this._publishAnalytics(activityDetailStore, analyticsStore);
    });
  };
  ActivityDetailController.prototype._fetchNewActivityServerPage = function (activityDetailStore, context, detailCriteriaStore, query) {
    this.clientSideFirstLoadRequested = true;
    return Promise.all([activityDetailStore.fetchActivityDetail(detailCriteriaStore.detailVariables, detailCriteriaStore, this.pageId, query)]);
  };
  ActivityDetailController.prototype._fetchNewActivityClientPage = function (activityDetailStore, detailCriteriaStore, query) {
    this.clientSideFirstLoadRequested = false;
    return activityDetailStore.fetchActivityDetail(detailCriteriaStore.detailVariables, detailCriteriaStore, this.pageId, query);
  };
  ActivityDetailController.prototype._getNewActivityFetchPromise = function (activityDetailStore, context, detailCriteriaStore, query, options) {
    if (options.isServer) {
      return this._fetchNewActivityServerPage(activityDetailStore, context, detailCriteriaStore, query);
    }
    return this._fetchNewActivityClientPage(activityDetailStore, detailCriteriaStore, query);
  };
  // eslint-disable-next-line class-methods-use-this
  // protected getReviewSeo(): Promise<any> {
  //   return Promise.resolve(fetch('/things-to-do/reviews-external'));
  // }
  // eslint-disable-next-line class-methods-use-this
  ActivityDetailController.prototype._publishAnalytics = function (activityDetailStore, analyticsStore) {
    var hasAnalytics = activityDetailStore.uisPayload;
    if (hasAnalytics) {
      analyticsStore.publishClientSidePayload(activityDetailStore.uisPayload);
    }
  };
  ActivityDetailController.prototype.fetchPageData = function (options) {
    var context = options.context;
    var siteId = options.request.context.site.id;
    var regionId = options.query.regionId;
    return Promise.resolve(__assign({}, getPageData(context, siteId, regionId, this.pageId)));
  };
  return ActivityDetailController;
}();
export { ActivityDetailController };